import React, {useState, useRef, useEffect, Fragment} from 'react';
import { ProgressHeader } from './ProgressHeader';
import {FieldDropdown, TextField, Divider, ViewLabelValueField, UserIcon, VisDiv} from '../../components';


export const StepByStepProgress = ({progressList}) => {

    const  [progressTab, setProgressTab] = useState(progressList[0])

    const activeIndex = progressList?.findIndex((x)=>x?.description == progressTab?.description)

    const nextStep = () => {
        //console.log("NEXT STEP")
        setProgressTab(progressList[activeIndex+1])
    }
    const previousStep = () => {
        //console.log("PREVIOUS STEP")
        setProgressTab(progressList[activeIndex-1])
    }
  return (
    <div>
        <ProgressHeader progressTab={progressTab} setProgressTab={setProgressTab} progressList={progressList}/>
        {progressList?.map?.((item, index)=>{
            return(
                <VisDiv key={index}  rules={[progressTab?.description == item?.description]}>
                    <h3>{item?.description}</h3>
                    {item?.component}
                </VisDiv>
            )
        })}
        <Divider/>
        <VisDiv style={{display:"flex", justifyContent:"space-around"}}>
            <VisDiv>
               {activeIndex>0 && <button className='pdf-button' onClick={previousStep}>PRECEDENTE</button>}
            </VisDiv>
            <VisDiv>
                {activeIndex < progressList?.length - 1 && <button className='pdf-button' onClick={nextStep}>SUCCESSIVO</button>}
            </VisDiv>
        </VisDiv>
      
    </div>
  )

}
